import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { Divider } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { CircularProgress } from "@mui/material";
import { useRef } from "react";
type Props = {};

const WardMasterAdd = (props: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    getVehicleZone();
  }, [])

  const getVehicleZone = () => {
    const collectData = {
      zoneID: -1,
      user_ID: -1,
      isActive: true
    };
    axios
      .post(HOST_URL.HOST_URL2 + `Zone/GetZonemaster`, collectData)
      .then((res) => {
        const arr: any = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["zoneName"],
            value: res.data.data[index]["zoneID"]
          });
        }
        setZoneOption(arr);
      });
  };
  const { t } = useTranslation();

  const [ZoneOption, setZoneOption] = useState([{ value: "-1", label: t("text.SelectZone") }]);


  let navigate = useNavigate();

  const back = useNavigate();
  const [toaster, setToaster] = useState(false);

  const validationSchema = Yup.object({
    zoneName: Yup.string().test(
      "required",
      t("text.req"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    wardName: Yup.string()
      .matches(/^[A-Za-z0-9\s]+$/, t("text.noSpecialChars")) // only letters, numbers, spaces
      .test("required", t("text.req1"), function (value: any) {
        return value && value.trim() !== "";
      }),
    wardCode: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, t("text.noSpecialChars")) // only letters and numbers
  });

  const formik = useFormik({
    initialValues: {
      zoneID: "",
      zoneName: "",
      wardName: "",
      wardCode: "",
      sortOrder: 0,
      isActive: true,
      user_ID: -1,
    },
    validationSchema: validationSchema,

    onSubmit: async (values) => {
      // Clear any existing timeout
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }

      // If already submitting, show message and return
      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }

      setIsSubmitting(true);

      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `Ward/AddUpdateWardmaster`,
          values
        );

        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate('/master/WardMaster');
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 429) {
          toast.error(t("text.tooManyRequests"));
        } else {
          toast.error(t("text.somethingWentWrong"));
        }
        setToaster(true);
      } finally {
        // Set a timeout to reset isSubmitting after 2 seconds
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    }
  });

  // Add cleanup effect
  React.useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);

  const requiredFields = ["zoneName", "wardName"];

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          border: ".5px solid #ff7722",
          marginTop: "3vh"
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ marginTop: "10px", fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.createWardMaster")}
          </Typography>
          <Grid xs={4} sm={12} item>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />


          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid container spacing={1}>
              <Grid xs={12} sm={4} item>

                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={ZoneOption}
                  value={
                    ZoneOption.find(
                      (option) => option.value === formik.values.zoneID
                    ) || null
                  }
                  fullWidth
                  size="small"
                  disabled={isSubmitting}

                  onChange={(event, newValue) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("zoneID", newValue?.value);
                    formik.setFieldValue("zoneName", newValue?.label);
                    formik.setFieldTouched("zoneID", true);
                    formik.setFieldTouched("zoneID", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={
                      <span>
                        {t("text.SelectZoneName")} {""}
                        {requiredFields.includes('zoneName') && (
                          <span style={{ color: formik.values.zoneName ? 'green' : 'red' }}>*</span>
                        )}
                      </span>
                    } />
                  )}
                />

                {formik.touched.zoneName && formik.errors.zoneName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.zoneName}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  name="wardName"
                  id="wardName"
                  label={
                    <span>
                      {t("text.enterWardName")}
                      {requiredFields.includes("wardName") && (
                        <span style={{ color: formik.values.wardName ? "green" : "red" }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.wardName}
                  placeholder={t("text.enterWardName")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor: formik.touched.wardName && formik.errors.wardName ? "red" : "initial",
                  }}
                  onChange={(e) => {
                    // allow only letters, numbers, spaces
                    const value = e.target.value.replace(/[^A-Za-z0-9\s]/g, "");
                    formik.setFieldValue("wardName", value);
                  }}
                  onBlur={formik.handleBlur}
                  inputProps={{ maxLength: 30 }}
                  disabled={isSubmitting}
                />
                {formik.touched.wardName && formik.errors.wardName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.wardName}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  value={formik.values.wardCode}
                  name="wardCode"
                  id="wardCode"
                  label={t("text.enterWardCode")}
                  placeholder={t("text.enterWardCode")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={(e) => {
                    // allow only letters and numbers
                    const value = e.target.value.replace(/[^A-Za-z0-9]/g, "");
                    formik.setFieldValue("wardCode", value);
                  }}
                  onBlur={formik.handleBlur}
                  inputProps={{ maxLength: 10 }}
                  disabled={isSubmitting}
                />
              </Grid>

              <Grid xs={12} item>
                <div style={{ justifyContent: "space-between", flex: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: `var(--header-background)`,
                      margin: "1%",
                    }}
                    disabled={isSubmitting}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isSubmitting ? t("text.submitting") : t("text.save")}
                  </Button>
                  <Button
                    type="reset"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#F43F5E",
                      margin: "1%",
                    }}
                    disabled={isSubmitting}
                    onClick={formik.handleReset}
                  >
                    {t("text.reset")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>

        </CardContent>
      </div>
    </div>
  );
};

export default WardMasterAdd;